import 'babel-polyfill'
import Vue from 'vue'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/utils/directive'
import { user } from '@/utils'
import Waiting from '@/components/plugin/waiting'
import ElementUI from 'element-ui'
import echarts from 'echarts'
import '@/styles/theme/index.css'
import '@/assets/fontceshi/iconfont.css'
import '@/styles/index.scss'
import "@/assets/iconfont/font-1.1/iconfont.css"
import 'normalize.css'
import moment from 'moment'
import myCharts from '@/utils/js/chart.js'
import scroll from 'vue-seamless-scroll'
import dataV from '@jiaminghi/data-view';
import './assets/scss/style.scss';
import '@/common/flexible.js';
import Icon from 'vue-awesome/components/Icon';
import 'vue-awesome/icons/chart-bar.js';
import 'vue-awesome/icons/chart-area.js';
import 'vue-awesome/icons/chart-pie.js';
import 'vue-awesome/icons/chart-line.js';
import 'vue-awesome/icons/align-left.js';
import hasPermission from '@/utils/hasPermission'

// 全局注册图标
Vue.component('icon', Icon);
Vue.use(dataV);
Vue.use(scroll)
Vue.use(myCharts)
Vue.use(ElementUI, { size: 'mini' })
Vue.use(Waiting)
// Vue.use(VueClipboard2)
Vue.config.productionTip = false
Vue.prototype.$getRegions = user.getRegions
Vue.prototype.$getCities = user.getCities
Vue.prototype.$echarts = echarts
Vue.prototype.$moment = moment
Vue.prototype.$bus = new Vue()
// Vue.config.silent = true  // 关闭Vue warn警告

import VueCron from 'vue-cron'
Vue.use(VueCron);//使用方式：<vueCron></vueCron>

Date.prototype.format = function (fmt) {
  var o = {
    "M+": this.getMonth() + 1, //月份
    "d+": this.getDate(), //日
    "H+": this.getHours(), //小时
    "m+": this.getMinutes(), //分
    "s+": this.getSeconds(), //秒
    "q+": Math.floor((this.getMonth() + 3) / 3), //季度
    "S": this.getMilliseconds() //毫秒
  };
  if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
  for (var k in o)
    if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
  return fmt;
}

// 按钮级权限鉴定
Vue.use(hasPermission)


new Vue({
  router,
  store,
  beforeCreate () {
    document.querySelector('body').setAttribute('style', 'background-color:#fff')
    // Vue.prototype.$bus = this // 创建全局事件总线
  },
  created(){
    let sessionStorageState = JSON.parse(sessionStorage.getItem("state"));
      //在页面加载时读取sessionStorage里的状态信息
      if (sessionStorageState) {
         this.$store.replaceState(Object.assign({}, this.$store.state,sessionStorageState.state));
      }
    //在页面刷新时将vuex里的信息保存到sessionStorage里
    window.addEventListener("beforeunload",()=>{
      sessionStorage.setItem("state", JSON.stringify({state:{app:this.$store.state.app,user:this.$store.state.user}}));
    })
  },
  render: h => h(App)
}).$mount('#app')


